export type SocialContentLanguageMode = "translated" | "original";

/** Default until user profile preference is implemented. */
export const DEFAULT_SOCIAL_CONTENT_LANGUAGE_MODE: SocialContentLanguageMode = "translated";

/**
 * Prefer the author's language when it matches the UI locale; otherwise show translations.
 */
export const resolveDefaultSocialContentLanguageMode = (
    uiLocale: string,
    originalLocale?: string | null,
): SocialContentLanguageMode => {
    if (!originalLocale) {
        return DEFAULT_SOCIAL_CONTENT_LANGUAGE_MODE;
    }

    const normalizedUi = uiLocale.split("-")[0].toLowerCase();
    const normalizedOriginal = originalLocale.split("-")[0].toLowerCase();

    return normalizedUi === normalizedOriginal ? "original" : DEFAULT_SOCIAL_CONTENT_LANGUAGE_MODE;
};

/**
 * Returns the default social content display mode.
 * Profile preference (`social.contentLanguageMode`) will be wired here later.
 */
export const useSocialContentLanguagePreference = () => ({
    mode: DEFAULT_SOCIAL_CONTENT_LANGUAGE_MODE,
    isLoading: false,
});
